<template>
    <section>
        <v-dialog max-width="600px" persistent v-model="confirmationDialog">
            <v-card>
                <div class="user_creation_popup_div">
                    <v-layout row wrap>
                        <v-flex xs12>
                            <v-card-title >
                                <span class="headline indigo--text">
                                    <v-icon medium>info_outline</v-icon> {{confirmationTitle}}
                                </span>
                            </v-card-title>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-card-text>
                            <v-flex xs12>
                                <span class="conformationText">Are you sure you want to {{confirmationText}} - {{name}}??? </span>
                            </v-flex>
                        </v-card-text>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12  class="save_in_merge">
                            <v-btn depressed color="grey lighten-3" id="actionBtn" :class="disableActionBtn?'disabled':''" @click="disableActionButton();$emit('action')">
                                Yes
                            </v-btn>
                            <v-btn depressed color="grey lighten-3" id="closePopup" @click="$emit('close')">
                                No
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </div>
            </v-card>
        </v-dialog>
    </section>
</template>
<script>
import Vue from 'vue';
export default {
    name: 'ConfirmationPopupVue',
    props:{
        name: {
            type: String,
            default : null
        },
        confirmationText: {
            type: String,
            default: null
        },
        confirmationTitle: {
            type: String,
            default: null
        },
    },
    data () {
        return {
            confirmationDialog : true,
            disableActionBtn : false,
        }
    },
    methods:{
        disableActionButton(){
            var self = this;
            self.disableActionBtn = true;
            setTimeout(function(){
                self.disableActionBtn = false;
            },2000);
        }
    }
}
</script>
